import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const CommonModal = ({
  isOpen,
  toggle,
  heading,
  contentBody,
  onConfirm,
  confirmText,
  cancelText,
  onCancel,
  acceptText,
  rejectText,
  modalSize,
  actionType,
  actionText,
  onAction
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop={"static"}
      className={`modal-dialog-centered modal-${modalSize?modalSize:"md"}`}
      scrollable={false}
      // zIndex={1000}
    >
      <ModalHeader  className="basebgColor text-light" toggle={toggle}>
        {heading}
      </ModalHeader>
      <ModalBody>{contentBody}</ModalBody>

      <ModalFooter className="bg-light">
        {cancelText && <button className="cancelBtn" onClick={onCancel}>{cancelText}</button>}{" "}
        {acceptText && <button  className="btn btn-success" onClick={onCancel}>{acceptText} Accept</button>}{" "}
        {rejectText && <button className="btn btn-danger" onClick={onCancel}>{rejectText} Reject</button>}{" "}
        {confirmText && (
          <Button className="basebgColor text-light px-3 py-1 rounded-3" onClick={onConfirm}>
            {confirmText}
          </Button>
        )}{" "}
        {
          actionType=="edit"&& (
            <Button className="basebgColor text-light px-3 py-1 rounded-3" onClick={onAction}>
            {actionText}
          </Button>
          )
        }

      </ModalFooter>
    </Modal>
  );
};

export default CommonModal;
